import { useState } from 'react'
import { AdaptersProvider } from './hooks/useAdapters'
import { BottomTabs, type TabId } from './components/ui/BottomTabs'
import { SearchScreen } from './screens/SearchScreen'
import { PublishScreen } from './screens/PublishScreen'
import { LocationScreen } from './screens/LocationScreen'
import { RadioScreen } from './screens/RadioScreen'
import { ProfileScreen } from './screens/ProfileScreen'
import { useSettings } from './hooks/useSettings'

function AppContent() {
  const [tab, setTab] = useState<TabId>('location')
  const { theme } = useSettings()

  const bg = theme === 'dark' ? '#0F0F0F' : '#F5F5F5'

  const screen = () => {
    switch (tab) {
      case 'search':   return <SearchScreen />
      case 'publish':  return <PublishScreen />
      case 'location': return <LocationScreen />
      case 'radio':    return <RadioScreen />
      case 'profile':  return <ProfileScreen />
    }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0,
      backgroundColor: bg,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      WebkitFontSmoothing: 'antialiased',
      transition: 'background-color 0.3s',
    }}>
      {screen()}
      <BottomTabs active={tab} onChange={setTab} />
    </div>
  )
}

export default function App() {
  return (
    <AdaptersProvider>
      <AppContent />
    </AdaptersProvider>
  )
}
